import { BadgeCheck } from "lucide-react";
import type { AskingPrice } from "../types";

const compact = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", notation: "compact", maximumFractionDigits: 2 });
const full = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export function askingPriceText(price: AskingPrice, detailed = false) {
  const format = (cents: number) => (detailed ? full : compact).format(cents / 100);
  return price.kind === "verified" ? format(price.amountCents) : `${format(price.lowCents)}–${format(price.highCents)}`;
}

export function AskingPriceDisplay({ price, detailed = false }: { price: AskingPrice; detailed?: boolean }) {
  const verified = price.kind === "verified";
  const accessible = verified ? `Verified builder asking price: ${askingPriceText(price, true)}` : `Estimated asking price range: ${askingPriceText(price, true)}`;
  return <div className={`asking-price ${verified ? "verified" : "estimated"}`} aria-label={accessible}>
    <strong>{askingPriceText(price, detailed)}</strong>
    <span>{verified ? <><BadgeCheck aria-hidden="true" />Builder asking price</> : "Estimated asking price"}</span>
  </div>;
}
